/**
 * Money units (Stage 7). The module gives integer minor units (pence). The
 * display components (SpecialFormattedNumber) use major units (pounds).
 * Convert at the display edge only, and compare in minor units.
 *
 * For an integer, `pence / 100` is the nearest double to the 2dp value, the
 * same number as `round(pence / 100, 2)` (the old adapter conversion).
 *
 * @param   {number} minor Integer minor units.
 * @returns {number}       Major units.
 */
// Stage 7.2 adds the voucher amount conversion
// eslint-disable-next-line import/prefer-default-export
export const toMajor = minor => minor / 100;
